import * as yup from 'yup';

import { Nullable } from '@clearverify/types';

import { DisclaimerInfoFragment } from 'src/api';

import { DisclaimerEditFormFields } from '../types';

export const getDisclaimerEditValidationSchema = (
  disclaimers: Nullable<DisclaimerInfoFragment>[],
) =>
  yup.object({
    [DisclaimerEditFormFields.name]: yup.string().nullable().required('Required Name'),
    [DisclaimerEditFormFields.disclaimer]: yup.string().nullable().required('Required Text'),
    [DisclaimerEditFormFields.titles]: yup
      .array()
      .min(1)
      .required('Required Titles')
      .test('test-titles', 'One of the titles is already exists', (titles: Nullable<string>[]) => {
        for (const disclaimer of disclaimers) {
          for (const title of titles) {
            if (!title || !disclaimer) {
              continue;
            }

            if (disclaimer.titles.includes(title)) {
              return false;
            }
          }
        }
        return true;
      }),
  });
